import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

const testimonials = [
  {
    name: "Mr. Hammad Khokhar",
    role: "8KW Solar System - LCS Sukkur",
    image: "👨‍💼",
    content:
      "I installed an 8KW solar system with Solid Era Energy and the results are outstanding. My electricity bills have dropped significantly and the system performance is excellent. Highly satisfied with their professional work and support.",
    rating: 5,
  },
  {
    name: "Hub Client",
    role: "6KW Solar Installation",
    image: "🏢",
    content:
      "Our 6KW solar system installation was smooth and efficient. The team handled everything professionally from setup to testing. We are now saving energy costs and enjoying uninterrupted power supply.",
    rating: 5,
  },
  {
    name: "Mr. Bashir Sanjrani",
    role: "4KW Solar System",
    image: "👨‍🔧",
    content:
      "Solid Era Energy provided an excellent 4KW solar solution for my home. The system is reliable, efficient, and has reduced my electricity expenses greatly. Their after-sales support is also very impressive.",
    rating: 5,
  },
];
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const variants = {
    enter: (dir) => ({
      x: dir > 0 ? 200 : -200,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (dir) => ({
      x: dir > 0 ? -200 : 200,
      opacity: 0,
    }),
  };

  return (
    <>
  
    <section id="testimonials"
      className="py-24 px-6 text-white relative"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.7), rgba(249,122,8,0.2)), url('/assets/s2.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="max-w-6xl mx-auto text-center">

        {/* HEADING */}
        <motion.h2
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-bold mb-4"
        >
          What Our Customers Say
        </motion.h2>

        <p className="text-white/70 mb-16">
          Join thousands of satisfied customers who switched to solar
        </p>

        {/* CARD */}
        <div className="relative flex justify-center items-center h-[350px]">

          <AnimatePresence custom={direction} mode="wait">
            <motion.div
              key={currentIndex}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.5 }}
              className="absolute w-full max-w-2xl"
            >
              <div
                className="p-10 rounded-2xl 
                bg-white/10 backdrop-blur-xl 
                border border-white/20
                shadow-[0_10px_50px_rgba(0,0,0,0.3)]
                hover:shadow-[0_10px_50px_rgba(249,115,22,0.4)]
                transition-all duration-300"
              >

                {/* ⭐ STARS */}
                <div className="flex justify-center mb-4">
                  {Array(testimonials[currentIndex].rating)
                    .fill(0)
                    .map((_, i) => (
                      <span key={i} className="text-yellow-400 text-xl drop-shadow">
                        ★
                      </span>
                    ))}
                </div>

                {/* TEXT */}
                <p className="text-white/90 text-lg leading-relaxed mb-6">
                  "{testimonials[currentIndex].content}"
                </p>

                {/* USER */}
                <div className="flex items-center justify-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-xl">
                    {testimonials[currentIndex].image}
                  </div>
                  <div className="text-left">
                    <h4 className="font-bold">
                      {testimonials[currentIndex].name}
                    </h4>
                    <p className="text-orange-400 text-sm">
                      {testimonials[currentIndex].role}
                    </p>
                  </div>
                </div>

              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* DOTS */}
        <div className="flex justify-center gap-2 mt-10">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentIndex(i)}
              className={`h-2 rounded-full transition-all ${
                i === currentIndex ? "w-8 bg-orange-400" : "w-2 bg-white/40"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
    </>
  );
}